import { ComponentProps, useLayoutEffect, useRef } from 'react';
import { Form } from 'react-bootstrap';

export const SelfFocusingInput = (props: ComponentProps<typeof Form.Control>) => {
  const inputRef = useRef<HTMLInputElement>(null);
  useLayoutEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);
  return <Form.Control ref={inputRef} {...props} />;
};
